<footer>
  <div id="stars-group-1"></div>
  <div id="stars-group-5"></div>
  <div class="footer-desktop">
    <div class="footer-content">
      <div class="align-items-center">
        <div id="nav-footer">
          <div class="d-flex justify-content-between footer-top-sec">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12 col-lg-3">
                  <div class="logo-img">
                    <img loading="lazy" src="../../assets/images/logo-black.svg" class="h-auto" alt="Saudi Space Agency" title="Saudi Space Agency" />
                  </div>
                </div>
                <div class="col-md-12 col-lg-9 right-side-col">
                  <div class="footer-links">
                    <ng-container *ngFor="let item of menuItems ;trackBy: trackByIndex">
                      <div class="footer-item has-child" [class.expanded]="item.expanded" *ngIf="item.showInFooter">
                        <h2>
                          <span [title]="item.nodeName" *ngIf="item.children.length > 0" (click)="isMobileView && toggleSubMenu(item)">{{ item.nodeName }}</span>
                          <a  aria-label="nodeName" [title]="item.nodeName" *ngIf="item.children.length === 0" [href]="item.url" [target]="item.target === 'New Tab' ? '_blank' : '_self'" rel="noopener noreferrer">{{ item.nodeName }}</a>
                        </h2>
                        <ul class="list-unstyled child-list" [style.display]="item.expanded ? 'block' : 'none'" [style.opacity]="item.expanded ? 1 : 0" [style.height]="item.expanded ? 'auto' : 0">
                          <ng-container *ngFor="let childItem of item.children ;trackBy: trackByIndex">
                            <li class="menu-link" *ngIf="childItem.showInFooter">
                              <a  aria-label="child Item url" [title]="childItem.url" [href]="childItem.url" [target]="childItem.target === 'New Tab' ? '_blank' : '_self'" rel="noopener noreferrer">{{ childItem.nodeName }}</a>
                            </li>
                          </ng-container>
                        </ul>
                      </div>
                    </ng-container>

                    <div class="footer-item d-flex flex-column mt-lg-47">
                      <!-- <h2 [title]="translation?.Contactinformation">{{translation?.Contactinformation}}</h2>
                      <ul class="list-unstyled child-list d-flex flex-column">
                        <li class="menu-link">
                          {{translation?.email}}: Info&#64;ssa.gov.sa
                        </li>
                      </ul> -->
                      <!-- <div class="re-edited-box-icon">
                        <a title="digital logo" href="https://raqmi.dga.gov.sa/platforms/platforms/bac6389c-0b42-470b-79f3-08dcbaa43419/platform-license">
                          <img src="../../assets/images/ssa-dga-min.webp" alt="digital logo" height="75.2" width="245" title="digital logo">
                        </a>
                      </div> -->
                      <div class="SocialMediaLinksfootercontainer desktop-social mt-auto">
                        <ul class="list-unstyled d-inline-flex">
                          <li >
                            <a  aria-label="instgram" href="https://www.instagram.com/saudispace.sa/?hl=en"  target="_blank" [title]="translation?.instgram"><span class="icon-instrgram"></span></a>
                          </li>
                          <li >
                            <a  aria-label="twitter" href="https://twitter.com/saudispace"  target="_blank" [title]="translation?.twitter"><span class="icon-twitter"></span></a>
                          </li>
                          <li >
                            <a  aria-label="linkedin"  href="https://www.linkedin.com/company/saudi-space/"  target="_blank" [title]="translation?.linkedin"><span class="icon-linkedin-2"></span></a>
                          </li>
                          <li >
                            <a  aria-label="facebook" href="https://www.facebook.com/saudispace.sa"  target="_blank" [title]="translation?.facebook"><span class="icon-facebook"></span></a>
                          </li>
                          <li >
                            <a  aria-label="youtube" href="https://www.youtube.com/@Saudispacesa"  target="_blank" [title]="translation?.youtube"><span class="icon-youtube"></span></a>
                          </li>
                          <li >
                            <a  aria-label="tiktok" href="https://www.tiktok.com/@saudi_space"  target="_blank" [title]="translation?.tiktok"><span class="icon-tiktok-2"></span></a>
                          </li>
                        </ul>
                      </div>
                    </div>

               

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="justify-content-between footer-bottom-sec">
            <div class="container d-flex justify-content-center">
              <p  [title]="translation?.footertext" class="copy-rights mb-0">{{translation?.footertext}} <span class="copy-icon">©</span>{{ currentYear }} </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
